import { AmountComponent, PriceComponent, PriceComponentWithCurrency } from "components/Table/CellComponents";
import {
    openAccountingDrawer,
    openFactorDrawer,
    openRemittanceDrawer,
    openTransactionDrawer,
    openTransferDrawer,
} from "../helpers/DrawerActions";

const productAccountCardFactorsColumns = [
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        clickable: (item: any) => true,
        onClick: (dispatch: any, item: any) => {
            if (item.type && item.type_id) {
                if (item.type === "factor") {
                    openFactorDrawer(dispatch, item);
                } else if (item.type === "transaction") {
                    openTransactionDrawer(dispatch, item);
                } else if (item.type === "transfer") {
                    openTransferDrawer(dispatch, item);
                } else if (item.type === "bill") {
                    openRemittanceDrawer(dispatch, item);
                }
            } else {
                openAccountingDrawer(dispatch, item);
            }
        },
    },
    {
        name: "شخص",
        key: "person",
        getValue: (item: any) => {
            if (typeof item.person === "string") return item.person;
        },
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
        navigateKey: (item: any) => item.personId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "خرید",
        key: "logIn",
        filterParams: {
            column: "buy",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    {
        name: "فروش",
        key: "logOut",
        filterParams: {
            column: "sell",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    // {
    //   name: "تراز",
    //   size: "4",
    //   key: "balance",
    //   price: true,
    //   Component: AmountComponent,
    // },
    {
        name: "مبلغ واحد",
        key: "price",
        getValue: (item: any) => {
            let price = item.totalPrice;
            if (item.logIn) price = price / item.logIn;
            if (item.logOut) price = price / item.logOut;
            return price;
        },
        filterParams: {
            column: "price",
            columnType: "number",
        },
        price: true,
        Component: PriceComponentWithCurrency,
        searchType: "quantitative",
    },
    {
        name: "مجموع فروش",
        key: "totalPrice",
        filterParams: {
            column: "totalPrice",
            columnType: "number",
        },
        price: true,
        Component: PriceComponentWithCurrency,
        searchType: "quantitative",
    },
];
const productAccountCardPersonsColumns = [
    {
        name: "نام",
        key: "person",
        getValue: (item: any) => {
            const name = item?.person?.nickName;
            if (name) return name;
            else return "";
        },
        filterParams: {
            column: "nickName",
            columnType: "string",
        },
        navigateKey: (item: any) => item.personId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "firstName",
        },
    },
    {
        name: "تعداد خرید",
        key: "buyProductsQuantity",
        filterParams: {
            column: "buyProductsQuantity",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    {
        name: "مبلغ خرید",
        key: "buyAmount",
        filterParams: {
            column: "buyAmount",
            columnType: "number",
        },
        price: true,
        Component: PriceComponent,
        searchType: "quantitative",
    },
    {
        name: "تعداد برگشت از خرید",
        key: "buyReturnProductsQuantity",
        filterParams: {
            column: "buyReturnProductsQuantity",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    {
        name: "مبلغ برگشت از خرید",
        key: "buyReturnAmount",
        filterParams: {
            column: "buyReturnAmount",
            columnType: "number",
        },
        price: true,
        Component: PriceComponent,
        searchType: "quantitative",
    },
    {
        name: "تعداد فروش",
        key: "saleProductsQuantity",
        filterParams: {
            column: "saleProductsQuantity",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    {
        name: "مبلغ فروش",
        key: "saleAmount",
        filterParams: {
            column: "saleAmount",
            columnType: "number",
        },
        price: true,
        Component: PriceComponent,
        searchType: "quantitative",
    },
    {
        name: "تعداد برگشت از فروش",
        key: "saleReturnProductsQuantity",
        filterParams: {
            column: "saleReturnProductsQuantity",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    {
        name: "مبلغ برگشت از فروش",
        key: "saleReturnAmount",
        filterParams: {
            column: "saleReturnAmount",
            columnType: "number",
        },
        price: true,
        Component: PriceComponent,
        searchType: "quantitative",
    },
];
const productAccountCardBillsColumns = [
    {
        name: "تاریخ",
        key: "date",
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: "date",
    },
    {
        name: "شماره",
        key: "accountingCode",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "شرح",
        key: "description",
        filterParams: {
            column: "description",
            columnType: "string",
        },
        clickable: (item: any) => true,
        onClick: (dispatch: any, item: any) => {
            openRemittanceDrawer(dispatch, { type_id: item.BillId, id: item.BillId });
        },
    },
    {
        name: "ورود",
        key: "logIn",
        getValue: (item: any) => {
            if (item.quantity > 0) return item.quantity;
            return 0;
        },
        filterParams: {
            column: "logIn",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    {
        name: "خروج",
        key: "logOut",
        getValue: (item: any) => {
            if (item.quantity < 0) return Math.abs(item.quantity);
            return 0;
        },
        filterParams: {
            column: "logOut",
            columnType: "number",
        },
        price: true,
        Component: AmountComponent,
        searchType: "quantitative",
    },
    // {
    //     name: "تراز",
    //     key: "balance",
    //     getValue: (item: any) => {
    //         return item.balance
    //     },
    //     // filterParams: {
    //     //     column: "balance",
    //     //     columnType: "number",
    //     // },
    //     price: true,
    //     Component: AmountComponent,
    //     // searchType: "quantitative",
    //     disableSearch: true,
    // },
];

export const productAccountCardIndexData = [
    {
        key: "productAccountFactors",
        apiKey: "factors",
        pageTitle: "کارت حساب کالا",
        pluralLabel: "فاکتور ها",
        title: "فاکتور ها",
        tableColumns: productAccountCardFactorsColumns,
        disableSearch: true,
        actions: {
            back: {},
        },
    },
    {
        key: "productAccountPersons",
        apiKey: "persons",
        pageTitle: "کارت حساب کالا",
        pluralLabel: "اشخاص",
        title: "اشخاص",
        tableColumns: productAccountCardPersonsColumns,
        disableSearch: true,
        actions: {
            back: {},
        },
    },
    {
        key: "productAccountBills",
        apiKey: "bills",
        pageTitle: "کارت حساب کالا",
        pluralLabel: "حواله انبار",
        title: "حواله انبار",
        tableColumns: [...productAccountCardBillsColumns, {
            name: "عنوان انبار",
            key: "warehouse",
            getValue: (item: any) => {
                return item?.warehouse
            },
            filterParams: {
                column: "warehouse",
                columnType: "string",
            },

        },],
        disableSearch: true,
        actions: {
            back: {},
        },
    },
];
